export type StatusQuo = typeof STATUS_QUO

export const STATUS_QUO = 'StatusQuo' as const
